module.exports = __webpack_public_path__ + "static/media/postman.f525ef6f.jpg";